// extracted by mini-css-extract-plugin
export default {"chip":"EnablePushChip_chip__pEIni"};